import React, { useState } from 'react';
import { db } from './firebaseConfig';
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const RegistrationForm = () => {
  const initialState = {
    name: '', nic: '', address: '', contact: '', land: '', email: '', 
    whatsapp: '', dob: '', alQual: '', olQual: '', experience: ''
  };

  const [formData, setFormData] = useState(initialState);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "student_registrations"), {
        ...formData,
        submittedAt: serverTimestamp()
      });
      
      // Success Notification
      alert("Successfully Saved!");
      
      // Reset all fields to empty
      setFormData(initialState);
    } catch (err) {
      alert("Error: " + err.message);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <form className="registration-form" onSubmit={handleSubmit}>
      <div className="form-grid">
        <h3>Basic Information</h3>
        <input type="text" name="name" value={formData.name} placeholder="Full Name" onChange={handleChange} required />
        <input type="text" name="nic" value={formData.nic} placeholder="NIC Number" onChange={handleChange} required />
        <input type="text" name="address" value={formData.address} placeholder="Address" onChange={handleChange} className="full-width" required />
        
        <h3>Contact Details</h3>
        <input type="tel" name="contact" value={formData.contact} placeholder="Contact No" onChange={handleChange} required />
        <input type="tel" name="land" value={formData.land} placeholder="Land No" onChange={handleChange} required />
        <input type="email" name="email" value={formData.email} placeholder="Email Address" onChange={handleChange} required />
        <input type="tel" name="whatsapp" value={formData.whatsapp} placeholder="WhatsApp No" onChange={handleChange} required />
        
        <div className="full-width">
           <label style={{fontSize: '14px', color: '#888', display: 'block', marginBottom: '5px'}}>Date of Birth</label>
           <input type="date" name="dob" value={formData.dob} onChange={handleChange} required />
        </div>

      </div>

      <button type="submit" className="submit-btn-creative">SUBMIT REGISTRATION</button>
    </form>
  );
};

export default RegistrationForm;